module.exports = __webpack_public_path__ + "img/example.186d8c24.png";